import Vue from "vue";
import DocumentTemplatesTable from "../components/tables/DocumentTemplatesTable";

Vue.component('document-templates', {
    components: { DocumentTemplatesTable }
});